// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bim-viewer__main>v-sheet[data-v-a6462ebe]{height:100vh}.bim-viewer .left_panel[data-v-a6462ebe]{margin-left:15px;margin-right:15px}.bim-viewer .itwin-compare[data-v-a6462ebe]{height:calc(100vh - 100px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
